var _jsxFileName = "/runner/_work/smpackages/smpackages/packages/webassets/src/components/Header/wrench/components/actions/ButtonUser.tsx",
  _this = this;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect } from 'react';
import ButtonSeatUpgrade from './ButtonSeatUpgrade';
import ButtonUpgrade from './ButtonUpgrade';
import ButtonTeam from './ButtonTeam';
import ButtonUsers from './ButtonUsers';
import { RbacPermissionType } from '../../../../../types';
import { useActionsQueryLazyQuery } from './Actions.generated';
var ButtonUser = function ButtonUser() {
  var _user$teamMembership, _user$package, _user$permissions, _user$permissions2, _user$features;
  var _useActionsQueryLazyQ = useActionsQueryLazyQuery(),
    _useActionsQueryLazyQ2 = _slicedToArray(_useActionsQueryLazyQ, 2),
    fetch = _useActionsQueryLazyQ2[0],
    _useActionsQueryLazyQ3 = _useActionsQueryLazyQ2[1],
    loading = _useActionsQueryLazyQ3.loading,
    data = _useActionsQueryLazyQ3.data;
  useEffect(function () {
    fetch();
  }, []);
  if (loading) return null;
  if (!(data !== null && data !== void 0 && data.user)) return null;
  var user = data === null || data === void 0 ? void 0 : data.user;
  var team = user.team;
  var teamMembership = (_user$teamMembership = user.teamMembership) !== null && _user$teamMembership !== void 0 ? _user$teamMembership : {
    isAdmin: false,
    memberType: ''
  };
  var _ref = (_user$package = user.package) !== null && _user$package !== void 0 ? _user$package : {},
    isAnnual = _ref.isAnnual;
  // Non-SSO users requires sm.features.users.invite to access /team/add
  // SSO users requires sm.features.users.view_users to see modal with invitation link under /team/users
  var canAddUsers = (team === null || team === void 0 ? void 0 : team.ssoState) === 'REQUIRED' ? (_user$permissions = user.permissions) === null || _user$permissions === void 0 ? void 0 : _user$permissions.includes(RbacPermissionType.UsersView) : (_user$permissions2 = user.permissions) === null || _user$permissions2 === void 0 ? void 0 : _user$permissions2.includes(RbacPermissionType.UsersInvite);
  var showSeatUpgradeButton = (user === null || user === void 0 ? void 0 : (_user$features = user.features) === null || _user$features === void 0 ? void 0 : _user$features.powerCasualEnabled) && teamMembership.memberType === 'CASUAL';
  if (showSeatUpgradeButton) {
    return /*#__PURE__*/React.createElement(ButtonSeatUpgrade, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 12
      }
    });
  }
  if (canAddUsers) {
    return /*#__PURE__*/React.createElement(ButtonUsers, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 39,
        columnNumber: 12
      }
    });
  }
  if (!team && isAnnual) {
    return /*#__PURE__*/React.createElement(ButtonTeam, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 12
      }
    });
  }
  if (!team) {
    return /*#__PURE__*/React.createElement(ButtonUpgrade, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 12
      }
    });
  }
  return null;
};
export default ButtonUser;
//# sourceMappingURL=ButtonUser.js.map